import hiraganaWordOrder from './hiragana_word_order.json';
import {WordOrder} from "./WordOrder";

export class HiraganaWordOrder extends WordOrder {
    protected rawWordOrder() {
        return hiraganaWordOrder;
    }
}


// WEBPACK FOOTER //
// ./src/HiraganaWordOrder.ts